import { render, staticRenderFns } from "./BottomTip.vue?vue&type=template&id=28830dee&scoped=true"
import script from "./BottomTip.vue?vue&type=script&lang=js"
export * from "./BottomTip.vue?vue&type=script&lang=js"
import style0 from "./BottomTip.vue?vue&type=style&index=0&id=28830dee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28830dee",
  null
  
)

export default component.exports